/*
 * @Description: '成功案例'河南广播电视台的路由设置
 * @Author: 贾博宁
 * @Date:202 -05
*/

export default [
    {
        path: '/cgal_hnws',
        component: resolve => require(['@/views/cgal_hnws'], resolve),
        name: 'cgal_hnws',
        meta: {
            nav: '湖南省外事侨务办公室出国（境）服务中心'
        }
    }

]



//////////////////
// WEBPACK FOOTER
// ./src/router/cgal_hnws
// module id = null
// module chunks = 